<template>
  <div v-if="active" class="overlay-spinner" :style="{'min-height': minHeight}">
    <div class="overlay-loader"></div>

    <spinner class="loader" :size="size" :color="color" :depth="depth"/>
  </div>
</template>

<script>
import Spinner from "vue-spinner-component/src/Spinner";

export default {
  components: {
    Spinner,
  },

  props: {
    active: {
      default: true,
      type: Boolean,
    },
    size: {
      default: 45,
      type: Number,
    },
    depth: {
      default: 4,
      type: Number,
    },
    color: {
      default: '#000000',
      type: String,
    },
    minHeight: {
      default: 'auto',
      type: String,
    },
  },
};
</script>

<style scoped>
  .overlay-loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    opacity: 0.9;
    z-index: 99;
  }

  .loader {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    margin: auto;
    z-index: 100;
  }
</style>
